import React from 'react';
import styled from 'styled-components';
import { FaCheck } from 'react-icons/fa';

export default function GarageTagSelector({
  label,
  hint,
  options,
  selected = [],
  onChange,
  hasError = false,
  errorMessage = '',
  fieldId,
}) {
  const set = new Set(Array.isArray(selected) ? selected : []);

  const toggle = (key) => {
    const next = set.has(key) ? [...set].filter((k) => k !== key) : [...set, key];
    onChange?.(next);
  };

  return (
    <Wrap>
      <Label id={fieldId}>{label} *</Label>
      {hint ? <Hint>{hint}</Hint> : null}
      <Grid role="group" aria-labelledby={fieldId}>
        {options.map((opt) => {
          const active = set.has(opt.key);
          return (
            <TagBtn key={opt.key} type="button" aria-pressed={active} $active={active} onClick={() => toggle(opt.key)}>
              <Check $active={active}>{active ? <FaCheck size={10} /> : null}</Check>
              {opt.label}
            </TagBtn>
          );
        })}
      </Grid>
      {errorMessage ? <ErrorText>{errorMessage}</ErrorText> : null}
      {!errorMessage && hasError ? <ErrorText>Select at least one option</ErrorText> : null}
    </Wrap>
  );
}

const Wrap = styled.div``;
const Label = styled.p`font-size: 12px; font-weight: 600; color: var(--pp-text); margin: 0 0 4px;`;
const Hint = styled.p`font-size: 11px; color: var(--pp-muted); margin: 0 0 10px;`;
const Grid = styled.div`display: flex; flex-direction: column; gap: 6px;`;
const TagBtn = styled.button`
  display: flex; align-items: center; gap: 10px; padding: 10px 12px; text-align: left;
  border-radius: var(--pp-radius-btn); cursor: pointer; font-size: 13px; color: var(--pp-text);
  border: 1px solid ${(p) => (p.$active ? 'var(--pp-brand)' : 'var(--pp-border)')};
  background: ${(p) => (p.$active ? 'var(--pp-brand-bg)' : 'var(--pp-surface)')};
`;
const Check = styled.span`
  width: 18px; height: 18px; border-radius: 4px; flex-shrink: 0;
  border: 1.5px solid ${(p) => (p.$active ? 'var(--pp-brand)' : 'var(--pp-border)')};
  background: ${(p) => (p.$active ? 'var(--pp-brand)' : 'var(--pp-surface)')};
  color: #fff; display: inline-flex; align-items: center; justify-content: center;
`;
const ErrorText = styled.p`font-size: 11px; color: var(--pp-error-text); margin: 6px 0 0;`;
